<template>
  <q-layout v-if="!isAdminRoute" view="lHh Lpr lFf" class="text-notarial-text">
    <Header />

    <q-page-container class="p-0 bg-notarial-bg no-header-offset">
      <div class="page-shell min-h-screen flex flex-col">
        <div class="page-content flex-grow">
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
        <Footer />
        <div v-if="isPropertyDetail" class="property-dock-spacer" aria-hidden="true"></div>
      </div>
    </q-page-container>

    <ConsultationFab v-if="!isPropertyDetail" />

    <button
        v-show="showBackToTop"
        type="button"
        aria-label="Volver al inicio"
        class="back-to-top"
        @click="scrollToTop"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
      </svg>
    </button>
  </q-layout>
  <router-view v-else />
</template>

<script setup>
import {computed, ref, onMounted, onUnmounted} from 'vue';
import { useRoute } from 'vue-router';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import ConsultationFab from '@/components/ConsultationFab.vue';

const showBackToTop = ref(false);
const route = useRoute();
const isAdminRoute = computed(() => route.matched.some((record) => record.meta.admin));
const isPropertyDetail = computed(() => route.name === 'property-detail');

const scrollToTop = () => {
  window.scrollTo({top: 0, behavior: 'smooth'});
};

const handleScroll = () => {
  showBackToTop.value = window.scrollY > 300;
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
.no-header-offset {
  padding-top: 0 !important;
  min-width: 0;
  overflow-x: clip;
}

.page-shell,
.page-content {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.page-content {
  overflow-x: clip;
}

.property-dock-spacer {
  height: 4.8rem;
  flex: 0 0 auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.back-to-top {
  position: fixed;
  right: 1.25rem;
  bottom: 5.7rem;
  z-index: 40;
  display: grid;
  width: 2.9rem;
  height: 2.9rem;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  background: #16343c;
  color: #fff;
  box-shadow: 0 12px 30px rgba(23, 37, 34, 0.2);
  cursor: pointer;
  transition: transform 180ms ease, background 180ms ease;
}

.back-to-top:hover {
  background: #0d262d;
  transform: translateY(-2px);
}

@media (max-width: 560px) {
  .back-to-top {
    display: none;
  }
}
</style>
